const WHATSAPP_LINK = 'https://wa.me/905321737544?text=Merhaba,%20Google%20reklam%C4%B1ndan%20ula%C5%9F%C4%B1yorum.%20Ak%C3%BC%20/%20yol%20yard%C4%B1m%20veya%20yedek%20par%C3%A7a%20hakk%C4%B1nda%20bilgi%20almak%20istiyorum.';
const PHONE_LINK_1 = 'tel:+905321737544';
const PHONE_LINK_2 = 'tel:+905364401984';

export default function FinalCTA() {
  return (
    <section id="iletisim" className="relative bg-brand-dark py-20 md:py-28 border-t border-brand-accent/30">
      <div className="w-full px-4 md:px-6 lg:px-8">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-2xl md:text-3xl lg:text-4xl xl:text-5xl font-bold text-white leading-tight mb-8 md:mb-10">
            Akü, Yol Yardım veya Yedek Parça İçin Hemen İletişime Geçin
          </h2>

          <div className="flex flex-col sm:flex-row gap-3 md:gap-4 justify-center mb-10 md:mb-12">
            <a
              href={WHATSAPP_LINK}
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center justify-center gap-3 bg-brand-accent hover:bg-brand-accentHover text-white font-bold text-base md:text-lg px-8 py-4 md:py-5 rounded-full transition-all duration-200 shadow-xl shadow-brand-accent/20 active:scale-95"
            >
              <i className="fab fa-whatsapp text-lg"></i>
              WhatsApp'tan Hemen Yaz
            </a>
            <a
              href={PHONE_LINK_1}
              className="flex items-center justify-center gap-3 bg-white hover:bg-gray-100 text-brand-dark font-bold text-base md:text-lg px-8 py-4 md:py-5 rounded-full transition-all duration-200 shadow-xl active:scale-95"
            >
              <i className="fas fa-phone"></i>
              Hemen Ara
            </a>
          </div>

          <div className="space-y-3 md:space-y-4">
            <div className="flex flex-col sm:flex-row items-center justify-center gap-3 md:gap-6">
              <a
                href={PHONE_LINK_1}
                className="text-white text-xl md:text-2xl font-bold hover:text-brand-accent transition-colors"
              >
                0532 173 75 44
              </a>
              <a
                href={PHONE_LINK_2}
                className="text-white text-xl md:text-2xl font-bold hover:text-brand-accent transition-colors"
              >
                0536 440 19 84
              </a>
            </div>
            <p className="text-brand-muted text-sm md:text-base">
              <a
                href="https://instagram.com/silivriotoyedekparcaa"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-white transition-colors"
              >
                Instagram: @silivriotoyedekparcaa
              </a>
            </p>
            <p className="text-brand-muted text-sm">
              İstanbul / Silivri
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}